module.exports = __webpack_public_path__ + "img/dash2-dark.b0e778c2.png";